// ** MUI Imports
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import { useAtom } from 'jotai'
import { Link, useLocation } from 'react-router-dom'
// ** Icon Imports
import Icon from 'src/@core/components/icon'
// ** Type Import
import { Settings } from 'src/@core/context/settingsContext'
import ModeToggler from 'src/@core/layouts/components/shared-components/ModeToggler'
import NotificationDropdown from 'src/@core/layouts/components/shared-components/NotificationDropdown'
import UserDropdown from 'src/@core/layouts/components/shared-components/UserDropdown'
import { currentModuleNameAtom, navItemsAtom, roleOptionsAtom, selectedRoleAtom } from 'src/atoms'
import { useUser } from 'src/hooks/useUser'
// ** Components
import Autocomplete from 'src/layouts/components/Autocomplete'
import { MvTypography } from '@/components/atoms/mv-typography'

interface Props {
  hidden: boolean
  settings: Settings
  toggleNavVisibility: () => void
  saveSettings: (values: Settings) => void
}

const SOLUTION_PREFIX = '/solutions'

const AppBarContent = (props: Props) => {
  // ** Props
  const { hidden, settings, saveSettings, toggleNavVisibility } = props
  const location = useLocation()
  const [roleOptions] = useAtom(roleOptionsAtom)
  const meQuery = useUser()
  const [, setNavItems] = useAtom(navItemsAtom)
  const [selectedRole, setSelectedRole] = useAtom(selectedRoleAtom)
  const [currentModuleName] = useAtom(currentModuleNameAtom)
  const isSolution = location.pathname.startsWith(SOLUTION_PREFIX)

  return (
    <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Box className='actions-left' sx={{ mr: 2, display: 'flex', alignItems: 'center' }}>
        {hidden && !settings.navHidden ? (
          <IconButton color='inherit' sx={{ ml: -2.75 }} onClick={toggleNavVisibility}>
            <Icon fontSize='1.5rem' icon='tabler:menu-2' />
          </IconButton>
        ) : (
          <Box>
            {isSolution ? (
              <MvTypography component='span' size='BODY_MD_NORMAL' sx={{ fontWeight: 700, color: 'primary.main' }}>
                {currentModuleName ?? ''}
              </MvTypography>
            ) : (
              'MVDP'
            )}
          </Box>
        )}
        <Autocomplete hidden={hidden} settings={settings} />
      </Box>
      <Box className='actions-right' sx={{ display: 'flex', alignItems: 'center' }}>
        <Tooltip title='Home'>
          <IconButton color='inherit' aria-label='Home' component={Link} to='/'>
            <Icon fontSize='1.5rem' icon='tabler:home' />
          </IconButton>
        </Tooltip>
        <NotificationDropdown settings={settings} />
        <Box sx={{ ml: 2 }}>
          <ModeToggler settings={settings} saveSettings={saveSettings} />
        </Box>
        <UserDropdown settings={settings} />
      </Box>
    </Box>
  )
}

export default AppBarContent
